import {
  TFormValue,
} from '../../../order/order-create-page/order-create-steps/add-lenses-step/add-lenses-step-form';

export const getFormPackages = (products: TFormValue[]): number => {
  return products.reduce((acc, item) => acc + Number(item.productQuantity), 0);
};
